import { getStorage, ref, getDownloadURL } from 'firebase/storage';

/**
 * Fetches the download URL for a document from Firebase Storage
 * @param {string} documentId - The ID of the document (without .pdf extension)
 * @param {string} folder - The folder name ('public' or 'private')
 * @returns {Promise<string>} - Resolves to the document URL or throws an error
 */
export const getDocumentUrl = async (documentId, folder) => {
  try {
    if (!documentId || !folder) {
      throw new Error('Document ID and folder are required');
    }

    if (folder !== 'public' && folder !== 'private') {
      throw new Error('Folder must be either "public" or "private"');
    }

    const storage = getStorage();
    const documentRef = ref(storage, `docs/${folder}/${documentId}.pdf`);
    const url = await getDownloadURL(documentRef);
    return url;
  } catch (error) {
    console.error('Error fetching document URL:', error);
    throw new Error('Failed to fetch document URL');
  }
};